import { render, staticRenderFns } from "./LoginResumeSession.vue?vue&type=template&id=5bb00420&scoped=true&"
import script from "./LoginResumeSession.vue?vue&type=script&lang=js&"
export * from "./LoginResumeSession.vue?vue&type=script&lang=js&"
import style0 from "./LoginResumeSession.vue?vue&type=style&index=0&id=5bb00420&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb00420",
  null
  
)

export default component.exports